<template>
  <div class="members-layout-container">
    <div class="members-layout-top">
      <div class="members-top-container">
        <div class="members-top-left">
          <h3 class="white--text">
            {{ preregistration.data.name }}
          </h3>
        </div>

        <div class="members-top-right">
          <v-menu offset-y right>
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="white" text v-bind="attrs" v-on="on">
                <div class="icon-button-container">
                  <div class="icon-button-text">
                    Hantera medlemmar
                  </div>
                  <div class="icon-button-icon">
                    <v-icon right style="color: rgba(255,255,255,1);">
                      mdi-menu-down
                    </v-icon>
                  </div>
                </div>
              </v-btn>
            </template>
          </v-menu>
        </div>

        <div class="members-top-usermenu">
          <user-menu></user-menu>
        </div>
      </div>
    </div>
    <div class="members-layout-actions-text">
      <h2 class="white--text">Medlemmar</h2>
    </div>
    <div class="members-layout-actions-buttons">
      <v-row>
        <v-btn color="white" class="color-a" text>Skicka föranmälan</v-btn>
        <v-btn color="white" class="color-a" text>Skicka inbjudan</v-btn>
      </v-row>
    </div>
    <div class="members-layout-content">
      <vue-editable-grid
        class="invites-table"
        ref="grid"
        id="mygrid"
        :column-defs="columnDefs"
        :row-data="attendents"
        row-data-key="id"
        @cell-updated="cellUpdated"
        @link-clicked="activeChanged"
        :enableFilters="false"
      >
      </vue-editable-grid>
    </div>
    <div class="members-layout-bottom"></div>
  </div>
</template>

<script>
import UserMenu from "@/components/UserMenu";
import PreregistrationsData from "@/assets/lib/preregistrations-data";

const preregistrationsData = PreregistrationsData();

function stopSubscription(self) {
  if (self.subscription) {
    self.subscription.attendentsSub();
    self.subscription.preregSub();
    self.subscription = null;
  }
}

function startSubscription(self) {
  if (
    !(
      self.subscription &&
      self.subscription.preregistrationId === self.preregistrationId
    )
  ) {
    console.log("startSubscription");
    stopSubscription(self);

    if (self.preregistrationId) {
      self.subscription = {
        preregistrationId: self.preregistrationId,
        attendentsSub: preregistrationsData.attendents(
          self.preregistrationId,
          newData => {
            console.log("attendentsSub got data");
            self.attendents = self.flattenData(newData);
          }
        ),
        preregSub: preregistrationsData.preregistration(
          self.preregistrationId,
          newData => {
            console.log("PreregSub:");
            console.log(newData);
            self.preregistration = newData;
          }
        )
      };
    }
  }
}

function columnDefinitions(weigthed) {
  let columns = [
    {
      field: "active",
      headerName: "Aktiv",
      type: "link",
      sortable: true,
      filter: true,
      editable: false
    },
    // {
    //   field: "ballot",
    //   headerName: "Röstsedel",
    //   sortable: true,
    //   filter: true,
    //   editable: true
    // },
    {
      field: "ssn",
      headerName: "Personnummer",
      sortable: true,
      filter: true,
      editable: false
    },
    {
      field: "name",
      headerName: "Namn",
      sortable: true,
      filter: true,
      editable: false
    }
  ];
  if (weigthed) {
    let sharesColumn = {
      field: "shares",
      headerName: "Andelar",
      type: "numeric",
      sortable: true,
      filter: true,
      editable: true
    };
    columns.splice(2, 0, sharesColumn);
  }
  return columns;
}

export default {
  components: {
    UserMenu
  },
  data() {
    return {
      subscription: null,
      attendents: [],
      preregistration: {}
    };
  },
  computed: {
    preregistrationId() {
      return this.$route.params.preregistrationId;
    },
    columnDefs() {
      return columnDefinitions(this.isWeighted);
    },
    isWeighted() {
      let weightModel = this.preregistration.data.weightModel;
      console.log("Vote weight model: " + weightModel);
      return weightModel === "weighted" || weightModel === "samfallighet";
    }
  },
  methods: {
    cellUpdated(data) {
      let fieldUpdate = {};
      fieldUpdate[data.column.field] = data.value;
      preregistrationsData.updatePreregistration(
        this.preregistrationId,
        data.row.id,
        fieldUpdate
      );
    },
    activeChanged(data) {
      let clickedInvite = this.attendents.find(
        invite => invite.id === data.rowData.id
      );
      clickedInvite.active = !clickedInvite.active;
      preregistrationsData.updatePreregistration(
        this.preregistrationId,
        clickedInvite.id,
        {
          active: clickedInvite.active
        }
      );
    },
    flattenData(attendent) {
      let result = attendent.map(attendent => {
        return {
          id: attendent.id,
          active: attendent.data.active ?? true,
          ballot: attendent.data.ballot ?? "",
          shares: attendent.data.shares ?? 1,
          ssn: attendent.data.ssn,
          name: attendent.data.name ?? "Okänd"
        };
      });
      return result;
    }
  },
  mounted() {
    console.log("mounted");
    startSubscription(this);
  },
  beforeRouteEnter(to, from, next) {
    next(self => {
      console.log("routeEnter");
      startSubscription(self);
    });
  },
  beforeRouteLeave(to, from, next) {
    console.log("routeLeave");
    stopSubscription(this);
    next();
  }
};
</script>

<style>
.members-layout-container {
  height: 100vh;
  display: grid;
  grid-template-columns: 1fr max-content;
  grid-template-rows: min-content min-content 1fr 0;
  gap: 12px 12px;
  grid-template-areas:
    "members-layout-top members-layout-top"
    "members-layout-actions-text members-layout-actions-buttons"
    "members-layout-content members-layout-content"
    "members-layout-bottom members-layout-bottom";
}

.members-layout-top {
  padding: 8px 16px;
  background: #002435;
  -webkit-box-shadow: 0 10px 5px 0 rgba(0, 0, 0, 0.25);
  -moz-box-shadow: 0 10px 5px 0 rgba(0, 0, 0, 0.25);
  box-shadow: 0 10px 5px 0 rgba(0, 0, 0, 0.25);
  grid-area: members-layout-top;
}

.members-layout-actions-text {
  padding-left: 16px;
  grid-area: members-layout-actions-text;
}

.members-layout-actions-buttons {
  padding-right: 28px;
  grid-area: members-layout-actions-buttons;
}

.members-layout-content {
  margin-left: 16px;
  margin-right: 16px;
  height: 100%;
  overflow-y: hidden;
  grid-area: members-layout-content;
}

.members-layout-bottom {
  grid-area: members-layout-bottom;
}

.members-top-container {
  display: grid;
  grid-template-columns: 36px auto 1fr auto auto auto;
  grid-template-rows: 1fr;
  gap: 0 0;
  grid-template-areas: "members-top-logo members-top-back members-top-left members-top-middle members-top-right members-top-usermenu";
}

.members-top-logo {
  padding-top: 7px;
  grid-area: members-top-logo;
  margin-right: 12px;
  align-self: end;
}

.members-top-back {
  grid-area: members-top-back;
}

.members-top-left {
  margin-left: 12px;
  align-self: center;
  grid-area: members-top-left;
}

.members-top-middle {
  grid-area: members-top-middle;
}

.members-top-right {
  grid-area: members-top-right;
}

.members-top-usermenu {
  grid-area: members-top-usermenu;
}

.mt-row {
  height: 40px;
  display: grid;
  grid-template-columns: 66px 100px 150px 1fr 1fr 1fr 1fr;
  grid-template-rows: 1fr;
  gap: 0px 0px;
  grid-template-areas: "mt-check mt-ballots mt-ssn mt-name mt-manual-name mt-phone mt-email";
}

.mt-check {
  grid-area: mt-check;
  align-self: center;
  justify-self: center;
}

.mt-ballots {
  grid-area: mt-ballots;
  align-self: center;
}

.mt-ssn {
  grid-area: mt-ssn;
  align-self: center;
}

.mt-name {
  grid-area: mt-name;
  align-self: center;
}

.mt-manual-name {
  grid-area: mt-manual-name;
  align-self: center;
}

.mt-phone {
  grid-area: mt-phone;
  align-self: center;
}

.mt-email {
  grid-area: mt-email;
  align-self: center;
}

input[type="text"]:focus {
  outline-width: 0px;
  border: none;
  /*border-bottom: 2px solid red;*/
}

.invites-table {
  height: 100%;
  background-color: white;
}
</style>
